<template>
  <div class="maintenance-page">
    <div class="maintenance-container">
      <div class="maintenance-icon">
        <i class="fa fa-info-circle fa-4x text-primary"></i>
      </div>
      <h2 class="mt-4">Pemberitahuan</h2>
      <p class="text-muted mt-3">
        Layanan <strong>Laporan Tahunan</strong> telah dialihkan ke aplikasi
        <strong>e-SEA Pengendalian</strong>. Untuk melakukan penyampaian Laporan
        Tahunan, silakan mengakses aplikasi melalui tombol di bawah ini.
      </p>
      <a
        href="https://app-sea.kkp.go.id/pengendalian"
        target="_blank"
        class="btn btn-primary mt-3"
      >
        <i class="fa fa-external-link mr-2"></i> Akses Aplikasi SEA Pengendalian
      </a>

      <p class="text-muted mt-4 mb-2">
        Apabila memerlukan informasi lebih lanjut atau mengalami kendala dalam
        mengakses aplikasi, silakan menghubungi kami melalui:
      </p>
      <a
        href="https://wa.me/6281110120010"
        target="_blank"
        class="btn btn-success mt-3"
      >
        <i class="fa fa-whatsapp mr-2"></i>0811-1012-0010
      </a>
      <br />
      <a
        href="mailto:pengendalian.prl@gmail.com"
        class="btn btn-secondary mt-3"
      >
        <i class="fa fa-envelope mr-2"></i>pengendalian.prl@gmail.com
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaporanTahunanMaintenance',
}
</script>

<style scoped>
.maintenance-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
.maintenance-container {
  text-align: center;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
}
.maintenance-icon {
  margin-bottom: 20px;
}
</style>
